module.exports = __webpack_public_path__ + "img/union1.3e338a52.png";